export default "__VITE_ASSET__cFm3ZAUR__"